<template>
  <v-select
    :label="title"
    :value="value"
    @input="$emit('input', $event)"
    :items="items"
    filled
    :hide-details="true"
    :rules="rules"
  ></v-select>
</template>

<script>
export default {
  name: "ContainerPicker",

  props: ["value", "title", "containers", "type", "isRequired"],

  computed: {
    items() {
      var result = [];

      if (this.containers) {
        this.containers.forEach((con) => {
          if (this.type) {
            if (this.type == con.type) result.push(con.name);
          } else result.push(con.name);
        });
      }

      return result;
    },
    rules() {
      if (this.isRequired) return [(v) => !!v || "Required"];
      return null;
    },
  },
};
</script>
